import { ListItemButton, styled } from '@mui/material'

export const StyledListItemButton = styled(ListItemButton)`
  background: #2c2e39;
`
